const DISTRICT_CODE_STORAGE_KEY = 'districtCode';

const toValidDistrictCode = (value: unknown): number | undefined => {
  const code = Number(value);
  return Number.isNaN(code) || !code ? undefined : code;
};

export const getStoredDistrictCode = (): number | undefined => {
  return toValidDistrictCode(localStorage.getItem(DISTRICT_CODE_STORAGE_KEY));
};

export const setSelectedDistrictCode = (code: number | undefined) => {
  if (code == null) return;
  localStorage.setItem(DISTRICT_CODE_STORAGE_KEY, String(code));
};

export const clearSelectedDistrictCode = () => {
  localStorage.removeItem(DISTRICT_CODE_STORAGE_KEY);
};

/** 优先使用本地已选区县，否则取用户默认区县， */
export const resolveInitialDistrictCode = (defDistrictCode?: unknown): number | undefined => {
  const stored = getStoredDistrictCode();
  if (stored != null) return stored;

  const defCode = toValidDistrictCode(defDistrictCode);
  if (defCode != null) return defCode;

  return undefined;
};